import { AbstractStatus, AbstractType } from '../../types'
import { AbstractSchema, AbstractReviewsSchema } from './Abstracts.schema'

export const defaultAbstract = (eventId: number): Partial<AbstractSchema> => ({
  id: -1,
  authors: [],
  figures: [],
  type: AbstractType[''],
  source: undefined,
  source_other: undefined,
  title: undefined,
  objective: undefined,
  materials_and_methods: undefined,
  results: undefined,
  conclusions: undefined,
  title_en: undefined,
  objective_en: undefined,
  materials_and_methods_en: undefined,
  results_en: undefined,
  conclusions_en: undefined,
  status: AbstractStatus.Draft,
  selection_status: undefined,
  event: eventId,
  domain: undefined,
  theme: undefined,
  keywords: [],
  _new: true,
})

export const defaultAbstractReview = (): Partial<AbstractReviewsSchema> => ({
  conflict_of_interest: '',
  score: null,
  proposed_topic_session: '',
  comment: '',
  has_conflict_of_interest: false,
})
